class Stats {
  constructor({ egrn_price, total_projects, co2_offset }) {
    this.egrn_price = egrn_price;
    this.total_projects = total_projects;
    this.co2_offset = co2_offset;
  }
}

export default Stats;
